import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import FloatingButtons from "./FloatingButtons";

export default function ClientRelationship() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const videos = [
    {
      id: "9wT2ERN6MfI",
      title: "BBR BASS BOAT RENTALS EXPLAINER",
    },
    {
      id: "NUW38hDdFWY",
      title: "HOW TO LIST YOUR BOAT",
    },
    {
      id: "0BfRYaAxbX0",
      title: "HOW TO LIST A KAYAK FOR RENT",
    },
    {
      id: "NUW38hDdFWY",
      title: "HOW TO LIST YOUR BOAT FOR RENT",
    },
    {
      id: "YrnQcwhvM4w",
      title: "HOW TO MAKE A BOOKING INQUIRY",
    },
    {
      id: "0FM4lapC0Ko",
      title: "HOW TO RENT A BASS BOAT",
    },
    {
      id: "oYwk7kCwg-M",
      title: "HOW TO RENT A JET SKI",
    },
    {
      id: "0BfRYaAxbX0",
      title: "HOW TO RENT A KAYAK",
    },
    {
      id: "bVm_9nnRsJg",
      title: "HOW TO START A TRIP FROM YOUR DASHBOARD",
    },
    {
      id: "o2HDLeZsDbY",
      title: "HOW TO ADVERTISE YOUR BOAT LISTING",
    },
    // {
    //   id: "Mat_3ebd2HI",
    //   title: "HOW TO RENT A BASS BOAT",
    // },
    {
      id: "bwHvnYlpAZE",
      title: "HOW TO GET VERIFIED",
    },
  ];

  return (
    <>
      <FloatingButtons />
      <section className="cs-bg-dark py-4 cs-section text-white privacy-policy">
        <div className="container">
          <Row className="mb-4">
            <Col>
              <Row className="mt-4">
                <Col>
                  <h1>How the platform works</h1>
                </Col>
              </Row>
              {videos.map((video, index) => (
                <Row className="mt-4" key={index}>
                  <h3 className="how-to-title text-white mb-2">
                    {video?.title}
                  </h3>
                  <Col>
                    <div
                      className="how-to-videos-wrapper relative mb-3"
                    >
                      <iframe
                        className="how-to-videos absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
                        src={`https://www.youtube.com/embed/${video?.id}`}
                        title={`YouTube video player ${index + 1}`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        style={{
                          width: "100%",
                          maxWidth: "800px",
                          height: "auto",
                          minHeight: "450px"
                        }}
                        allowFullScreen
                      ></iframe>
                    </div>
                  </Col>
                </Row>
              ))}
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}
